/**
 * @generated SignedSource<<8d0925016cb505d7856227fcee0bc937>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export interface CommentBody {
  representationFormat: ContentRepresentation;
  value: Scalars["String"]["input"];
}
export enum ContentRepresentation {
  ATLAS_DOC_FORMAT = "ATLAS_DOC_FORMAT",
  EDITOR = "EDITOR",
  EDITOR2 = "EDITOR2",
  EXPORT_VIEW = "EXPORT_VIEW",
  PLAIN = "PLAIN",
  RAW = "RAW",
  STORAGE = "STORAGE",
  STYLED_VIEW = "STYLED_VIEW",
  VIEW = "VIEW",
  WIKI = "WIKI",
}
export interface CreateCommentInput {
  commentBody: CommentBody;
  commentSource?: InputMaybe<Platform>;
  containerId: Scalars["ID"]["input"];
  parentCommentId?: InputMaybe<Scalars["ID"]["input"]>;
}
export enum Platform {
  ANDROID = "ANDROID",
  IOS = "IOS",
  WEB = "WEB",
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type CreateGeneralReplyMutation_createFooterComment_Comment_author_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_author_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: CreateGeneralReplyMutation_createFooterComment_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_author_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: CreateGeneralReplyMutation_createFooterComment_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_author_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: CreateGeneralReplyMutation_createFooterComment_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_author_User =
  {
    __typename?: "User";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: CreateGeneralReplyMutation_createFooterComment_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_author =
  | CreateGeneralReplyMutation_createFooterComment_Comment_author_Anonymous
  | CreateGeneralReplyMutation_createFooterComment_Comment_author_KnownUser
  | CreateGeneralReplyMutation_createFooterComment_Comment_author_UnknownUser
  | CreateGeneralReplyMutation_createFooterComment_Comment_author_User;
export type CreateGeneralReplyMutation_createFooterComment_Comment_body_DocumentBody =
  {
    __typename?: "DocumentBody";
    value: string;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_createdAt_ConfluenceDate =
  {
    __typename?: "ConfluenceDate";
    value: string;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_links_Map_LinkType_String =
  {
    __typename?: "Map_LinkType_String";
    webui: string | null;
    editui: string | null;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolvedTime: number | null;
    resolvedFriendlyDate: string | null;
    resolvedUser: string | null;
    resolved: boolean;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    isDangling: boolean;
    resolvedTime: number | null;
    resolvedFriendlyDate: string | null;
    resolvedUser: string | null;
    resolved: boolean;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_location_FooterComment =
  {
    __typename?: "FooterComment";
    type: string;
    commentResolveProperties: CreateGeneralReplyMutation_createFooterComment_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties | null;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_location_InlineComment =
  {
    __typename?: "InlineComment";
    inlineMarkerRef: string | null;
    inlineText: string | null;
    type: string;
    inlineResolveProperties: CreateGeneralReplyMutation_createFooterComment_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties | null;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_location =
  | CreateGeneralReplyMutation_createFooterComment_Comment_location_FooterComment
  | CreateGeneralReplyMutation_createFooterComment_Comment_location_InlineComment;
export type CreateGeneralReplyMutation_createFooterComment_Comment_permissions_CommentPermissions =
  {
    __typename?: "CommentPermissions";
    isEditable: boolean;
    isRemovable: boolean;
    isResolvable: boolean;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_reactionsSummary_ReactionsSummaryResponse_reactionsSummaryForEmoji_ReactionsSummaryForEmoji =
  {
    __typename?: "ReactionsSummaryForEmoji";
    id: string;
    emojiId: string;
    count: number;
    reacted: boolean;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_reactionsSummary_ReactionsSummaryResponse =
  {
    __typename?: "ReactionsSummaryResponse";
    ari: string;
    containerAri: string;
    reactionsCount: number;
    reactionsSummaryForEmoji: Array<CreateGeneralReplyMutation_createFooterComment_Comment_reactionsSummary_ReactionsSummaryResponse_reactionsSummaryForEmoji_ReactionsSummaryForEmoji | null>;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_version_Version_by_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_version_Version_by_KnownUser =
  {
    __typename?: "KnownUser";
    displayName: string | null;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_version_Version_by_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_version_Version_by_User =
  {
    __typename?: "User";
    displayName: string | null;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment_version_Version_by =

    | CreateGeneralReplyMutation_createFooterComment_Comment_version_Version_by_Anonymous
    | CreateGeneralReplyMutation_createFooterComment_Comment_version_Version_by_KnownUser
    | CreateGeneralReplyMutation_createFooterComment_Comment_version_Version_by_UnknownUser
    | CreateGeneralReplyMutation_createFooterComment_Comment_version_Version_by_User;
export type CreateGeneralReplyMutation_createFooterComment_Comment_version_Version =
  {
    __typename?: "Version";
    when: string | null;
    number: number | null;
    by: CreateGeneralReplyMutation_createFooterComment_Comment_version_Version_by | null;
  };
export type CreateGeneralReplyMutation_createFooterComment_Comment = {
  __typename?: "Comment";
  id: string;
  contentStatus: string;
  createdAtNonLocalized: string;
  parentId: string | null;
  author: CreateGeneralReplyMutation_createFooterComment_Comment_author;
  body: CreateGeneralReplyMutation_createFooterComment_Comment_body_DocumentBody;
  createdAt: CreateGeneralReplyMutation_createFooterComment_Comment_createdAt_ConfluenceDate;
  links: CreateGeneralReplyMutation_createFooterComment_Comment_links_Map_LinkType_String;
  location: CreateGeneralReplyMutation_createFooterComment_Comment_location;
  permissions: CreateGeneralReplyMutation_createFooterComment_Comment_permissions_CommentPermissions;
  reactionsSummary: CreateGeneralReplyMutation_createFooterComment_Comment_reactionsSummary_ReactionsSummaryResponse | null;
  version: CreateGeneralReplyMutation_createFooterComment_Comment_version_Version;
};
export type CreateGeneralReplyMutation_Mutation = {
  __typename?: "Mutation";
  createFooterComment: CreateGeneralReplyMutation_createFooterComment_Comment;
};
export type CreateGeneralReplyMutationVariables = Exact<{
  pageId: Scalars["ID"]["input"];
  cloudId: Scalars["ID"]["input"];
  input: CreateCommentInput;
}>;
export type CreateGeneralReplyMutation = CreateGeneralReplyMutation_Mutation;
